import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, first, map, tap } from 'rxjs';

import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UnauthedRedirectGuard {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.authService.isLoggedIn().pipe(
      first(),
      tap((isLoggedIn) => {
        if (isLoggedIn) {
          this.router.navigate(['']);
        }
      }),
      map((result: boolean) => !result)
    );
  }
}
